import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Select from "../../../form/select/Select";
import * as Yup from "yup";
import useFileUpload from "../../../../utils/hooks/useFileUpload";
import { FileUploader } from "react-drag-drop-files";
import { updateCustomerIdentityInfo } from "../../../../redux/slice/customer/customerSlice";
import { useDispatch, useSelector } from "react-redux";

const idType = [
  { id: "drivers_license", name: "Drivers License" },
  { id: "national_id", name: "National ID Card" },
  { id: "passport", name: "National Passport" },
  { id: "voters_card", name: "Voter's Card" },
];
const MeansOfIdentification = ({ data, data1 }) => {
  const [editing, setEditing] = useState(false);
  const [isUploading, setIsUploading] = useState(false);

  const [editCustomer, setEditCustomer] = useState();

  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const idName = idType.find((el) => el.id === data?.identity_type);

  const dispatch = useDispatch();

  const { fileUrl, singleFileUpload } = useFileUpload();

  const identityData = idType?.map((state) => {
    return {
      label: state.name,
      value: state.id,
    };
  });

  const onSubmit = (values) => {
    if (!isUploading) {
      let payload = {
        ...values,
        document_url: fileUrl,
        id: data?.customer_uuid,
      };
      dispatch(updateCustomerIdentityInfo(payload));
    }
  };

  const handleFileChange = (file) => {
    setIsUploading(true);
    singleFileUpload(file);
  };

  const handleClose = () => {
    values.identity_type = data?.identity_type;
    values.date_of_insurance = data?.date_of_insurance;
    values.date_of_expiration = data?.date_of_expiration;
    values.identity_number = data?.identity_number;
  };

  const fileTypes = ["JPG", "PNG", "JPEG", "PDF", "DOC", "DOCX"];

  const validationScehma = Yup.object().shape({
    identity_type: Yup.string("Staff Id must be a string").required(
      "Identification type cannot be blank"
    ),
    // date_of_insurance: Yup.string("First Name must be a string").required(
    //   "Date of Issuance cannot be blank"
    // ),
    // date_of_expiration: Yup.string("Last Name must be a string").required(
    //   "Expiration date cannot be blank"
    // ),
    identity_number: Yup.string("Last Name must be a string").required(
      "Identification Number cannot be blank"
    ),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      identity_type: data?.identity_type || "",
      date_of_insurance: data?.date_of_insurance || "",
      date_of_expiration: data?.date_of_expiration || "",
      identity_number: data?.identity_number || "",
    },
    validationSchema: validationScehma,
    validate: (values) => {
      let errors = {};

      if (values?.identity_type !== "national_id") {
        if (!values?.date_of_insurance) {
          errors.date_of_insurance = "Date of Issuance cannot be blank";
        }
        if (!values?.date_of_expiration) {
          errors.date_of_expiration = "Date of Expiration cannot be blank";
        }
      }

      return errors;
    },
    onSubmit,
  });

  useEffect(() => {
    if (fileUrl) {
      setIsUploading(false);
    }
  }, [fileUrl]);

  useEffect(() => {
    setEditCustomer(
      user_permissions?.some(
        (permission) => permission.name === "edit customer - individual"
      )
    );
  }, [user_permissions]);
  return (
    <>
      <form
        className='border p-3 rounded-3 mt-4 position-relative'
        onSubmit={handleSubmit}
      >
        <h4 className='fw-semibold text-primary-1 bg-white position-absolute profile-title'>
          Means of Identification
        </h4>
        <div className='row'>
          <div className='col-md-12'>
            <div className='row mb-2'>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='firstName ' className='fw-bold pb-1'>
                      Identification Type
                    </label>
                    {!editing ? (
                      <p className='text-capitalize'>{idName?.name}</p>
                    ) : (
                      <div>
                        <Select
                          onBlur={() => {
                            handleBlur({ target: { name: "identity_type" } });
                          }}
                          name='identity_type'
                          data={identityData}
                          value={values.identity_type}
                          onChange={(selectedOption) =>
                            setFieldValue(
                              "identity_type",
                              selectedOption?.value
                            )
                          }
                        />
                        {errors?.identity_type && touched?.identity_type && (
                          <p className='mb-0 text-danger'>
                            {errors?.identity_type + "*"}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                  <div className='col-sm-6 col-md-6'>
                    <label htmlFor='lastname' className='fw-bold pb-1'>
                      Identification Number
                    </label>
                    {!editing ? (
                      <p>{data?.identity_number}</p>
                    ) : (
                      <div>
                        <input
                          className='form-control form-control-sm'
                          id='identity_number'
                          value={values.identity_number}
                          type='number'
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.identity_number &&
                          touched?.identity_number && (
                            <p className='mb-0 text-danger'>
                              {errors?.identity_number + "*"}
                            </p>
                          )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {values.identity_type !== "national_id" ? (
                <div className='col-md-6'>
                  <div className='row'>
                    <div className='col-sm-6 col-md-6'>
                      <label htmlFor='middlename' className='fw-bold pb-1'>
                        Date of Issuance
                      </label>
                      {!editing ? (
                        <p>
                          {moment(`${data?.date_of_insurance}`).format("L")}
                        </p>
                      ) : (
                        <div>
                          <input
                            className='form-control form-control-sm'
                            type={"date"}
                            name='date_of_insurance'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            defaultValue={values?.date_of_insurance}
                          />
                          {errors?.date_of_insurance &&
                            touched?.date_of_insurance && (
                              <p className='mb-0 text-danger'>
                                {errors?.date_of_insurance + "*"}
                              </p>
                            )}
                        </div>
                      )}
                    </div>
                    <div className='col-sm-6 col-md-6'>
                      <label htmlFor='middlename' className='fw-bold pb-1'>
                        Date of Expiry
                      </label>
                      {!editing ? (
                        <p>
                          {moment(`${data?.date_of_expiration}`).format("L")}
                        </p>
                      ) : (
                        <div>
                          <input
                            className='form-control form-control-sm'
                            type={"date"}
                            name='date_of_expiration'
                            onChange={handleChange}
                            onBlur={handleBlur}
                            defaultValue={values?.date_of_expiration}
                          />
                          {errors?.date_of_expiration &&
                            touched?.date_of_expiration && (
                              <p className='mb-0 text-danger'>
                                {errors?.date_of_expiration + "*"}
                              </p>
                            )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className='col-md-4'></div>
              )}
            </div>
            <div className='col-sm-6 col-md-2'></div>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <div className='d-flex justify-content-between align-content-center'>
              <div className=''>
                {!editing ? (
                  <div className='d-flex'>
                    <a
                      href={data?.document_url}
                      target='_blank'
                      rel='noreferrer'
                    >
                      <div className='btn btn-primary btn-sm mt-3 px-4 text-white'>
                        <i className='mdi mdi-eye text-white fs-5'></i>
                      </div>
                    </a>
                  </div>
                ) : (
                  <div className='d-flex'>
                    <FileUploader
                      label=' Browse Document'
                      children={
                        <div
                          className='borde border-dotted p-1 px-1 text-center cursor-p mt-2'
                          style={{ border: "2px dashed grey" }}
                        >
                          <i className='uil uil-cloud-upload fs-4'></i> Document
                          <span className='text-primary-dark mt-0'></span>
                        </div>
                      }
                      handleChange={handleFileChange}
                      onDrop={handleFileChange}
                      name='file'
                      types={fileTypes}
                    />
                    {isUploading && (
                      <span className='bg-dar ms-1 text-danger mt-3'>
                        {" "}
                        <i
                          className={`mdi mdi-dots-circle mdi-spin fs-5 h3 mt-0`}
                        ></i>{" "}
                      </span>
                    )}
                    {!isUploading && fileUrl && (
                      <span className='bg-dar ms-1 text-success mt-3'>
                        {" "}
                        <i className={`mdi mdi-check fs-5 h3 mt-0`}></i>{" "}
                      </span>
                    )}
                  </div>
                )}
              </div>
              {editCustomer && data1?.status !== "3" && (
                <div className='d-flex justify-content-end'>
                  <div>
                    <button
                      type='button'
                      className={`btn btn-${
                        editing ? "warning" : "info"
                      } btn-sm mt-3 px-4 text-white`}
                      onClick={() => {
                        setEditing(editing ? false : true);
                        handleClose();
                      }}
                    >
                      {editing ? "Close" : "Edit"}
                    </button>
                    {editing && (
                      <button
                        className='btn btn-success ms-2 btn-sm mt-3 px-4'
                        type='submit'
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default MeansOfIdentification;
